import type { KubernetesLiveStatusDetailedResource } from "@octopusdeploy/octopus-server-client";

export function flattenResourceHierarchy(resource: KubernetesLiveStatusDetailedResource): KubernetesLiveStatusDetailedResource[] {
    const flat = (value: KubernetesLiveStatusDetailedResource): KubernetesLiveStatusDetailedResource[] => [value, ...value.Children.flatMap(flat)];
    return [resource, ...resource.Children.flatMap(flat)];
}
